import {
  CardToUploadByUserIdRequestType,
  CardToUploadByUserIdResponseType,
  CardToUploadBatchCreateRequestType,
  CardToUploadBatchCreateResponseType,
  CardToUploadStatusCardMarketEnum,
  CardToUploadStatusCardTraderEnum,
} from "magic-shared-types";
import { api } from "../api";
import { BASE_SERVER_PATH } from "../../constant";

export const myServerApis = api.injectEndpoints({
  endpoints: (builder) => ({
    getCardToUploadByUserId: builder.query<
      CardToUploadByUserIdResponseType,
      CardToUploadByUserIdRequestType
    >({
      query: ({ page, pageSize, status_ct, status_cm, game_id, name }) => ({
        url: `${BASE_SERVER_PATH}/api/card-to-upload/user`,
        method: "GET",
        params: { page, pageSize, status_ct, status_cm, game_id, name },
        headers: {
          "x-requires-auth": "true",
        },
      }),
    }),
    batchCreateCardTraderToUpload: builder.mutation<
      CardToUploadBatchCreateResponseType,
      { cards: CardToUploadBatchCreateRequestType[] }
    >({
      query: (body) => ({
        url: `${BASE_SERVER_PATH}/api/card-to-upload/batch`,
        method: "POST",
        body,
        headers: {
          "x-requires-auth": "true",
        },
      }),
    }),
    updateUploadStatus: builder.mutation<
      { success: true },
      {
        status_cm?: CardToUploadStatusCardMarketEnum;
        status_ct?: CardToUploadStatusCardTraderEnum;
        uploadId: number;
      }
    >({
      query: ({ status_cm, status_ct, uploadId }) => ({
        url: `${BASE_SERVER_PATH}/api/card-to-upload/${uploadId}/change-cm-ct-status`,
        method: "POST",
        body: { status_cm, status_ct },
        headers: {
          "x-requires-auth": "true",
        },
      }),
    }),
  }),
});

export const {
  useGetCardToUploadByUserIdQuery,
  useBatchCreateCardTraderToUploadMutation,
  useUpdateUploadStatusMutation,
} = myServerApis;
